import {addFilterCrit, Filter, removeFilterCrit} from "./structs/Filter";
import {Crit} from "./structs/Crit";
import {Search} from "./Search";
import {ZpCalendar} from "./ZpCalendar";
import {Zp, ZpDate} from "./Zp";

declare global {
    interface HTMLElement {
        noUiSlider?: {
            on: (typ: 'update' | 'change', call: (values: string[], handle?: number) => void) => void;
            set: (vals: number[]) => void;
        };
    }

    interface Window {
        noUiSlider: {
            create: (el: HTMLElement, options: {}) => void
        }
    }
}

export class SearchForm {
    static filter: Filter = null;
    static changeFilter: () => void = null;
    static cal: ZpCalendar;
    static calFrom: ZpDate = 0;
    static calTill: ZpDate = 0;

    static init(filter: Filter, changeFilter: () => void) {
        SearchForm.filter = filter;
        SearchForm.changeFilter = changeFilter;

        $('#formPax1, #formPax2').on('change', function () {
            switch ($(this).val()) {
                case "2":
                    addFilterCrit(filter, Crit.PersonsFrom2);
                    break;
                case "3":
                    addFilterCrit(filter, Crit.PersonsFrom3);
                    break;
                case "4":
                    addFilterCrit(filter, Crit.PersonsFrom4);
                    break;
                case "5":
                    addFilterCrit(filter, Crit.PersonsFrom5);
                    break;
                case "6":
                    addFilterCrit(filter, Crit.PersonsFrom6);
                    break;
                case "7":
                    addFilterCrit(filter, Crit.PersonsFrom7);
                    break;
                case "8":
                    addFilterCrit(filter, Crit.PersonsFrom8);
                    break;
                case "9":
                    addFilterCrit(filter, Crit.PersonsFrom9);
                    break;
                case "10":
                    addFilterCrit(filter, Crit.PersonsFrom10);
                    break;
                default:
                    removeFilterCrit(filter, Crit.PersonsFrom2);
                    break;
            }
            changeFilter();
        });

        const priceRange = $('#price-range');
        const marginMin = $('#slider-margin-value-min');
        const marginMax = $('#slider-margin-value-max');
        if (priceRange.length) {
            window.noUiSlider.create(priceRange[0], {
                start: [10, 1000],
                connect: true,
                behaviour: 'tap-drag',
                range: {
                    'min': 10,
                    '33%': [100, 5],
                    '66%': [330, 10],
                    'max': 1000
                }
            });

            priceRange[0].noUiSlider.on('update', function (val, h) {
                const v = parseInt(val[h]);
                if (h) {
                    marginMax.html(window.pageInfo.currency + ' ' + v.toLocaleString() + (v === 1000 ? "+" : ""));
                } else {
                    marginMin.html(window.pageInfo.currency + ' ' + v.toLocaleString());
                }
            });

            priceRange[0].noUiSlider.on('change', (val) => {
                const priceFrom = parseInt(val[0]);
                const priceTo = parseInt(val[1]);
                // gibt den von und bis Preis an, (x & 0x3ff) = von, (x >> 10) = bis, jeweils 0 = nicht gesetzt
                filter.price_from_to = 0;
                if (priceFrom > 10) filter.price_from_to |= priceFrom;
                if (priceTo < 1000) filter.price_from_to |= priceTo << 10;
                changeFilter();
            });
        }

        $('#formBedrooms').on('change', function () {
            switch ($(this).val()) {
                case "1":
                    addFilterCrit(filter, Crit.BedroomFrom1);
                    break;
                case "2":
                    addFilterCrit(filter, Crit.BedroomFrom2);
                    break;
                case "3":
                    addFilterCrit(filter, Crit.BedroomFrom3);
                    break;
                case "4":
                    addFilterCrit(filter, Crit.BedroomFrom4);
                    break;
                default:
                    removeFilterCrit(filter, Crit.BedroomFrom1);
                    break;
            }
            changeFilter();
        });

        $('#formDistWater').on('change', function () {
            switch ($(this).val()) {
                case "250":
                    addFilterCrit(filter, Crit.WaterTill250);
                    break;
                case "500":
                    addFilterCrit(filter, Crit.WaterTill500);
                    break;
                case "1000":
                    addFilterCrit(filter, Crit.WaterTill1000);
                    break;
                case "10000":
                    addFilterCrit(filter, Crit.WaterTill10000);
                    break;
                default:
                    removeFilterCrit(filter, Crit.WaterTill250);
                    break;
            }
            changeFilter();
        });

        $('#formDistSkilift').on('change', function () {
            switch ($(this).val()) {
                case "250":
                    addFilterCrit(filter, Crit.SkiliftTill250);
                    break;
                case "500":
                    addFilterCrit(filter, Crit.SkiliftTill500);
                    break;
                case "1000":
                    addFilterCrit(filter, Crit.SkiliftTill1000);
                    break;
                case "10000":
                    addFilterCrit(filter, Crit.SkiliftTill10000);
                    break;
                default:
                    removeFilterCrit(filter, Crit.SkiliftTill250);
                    break;
            }
            changeFilter();
        });

        $('#amenities input[type="checkbox"], #crit_' + Crit.TypeHolidayhome + ', #crit_' + Crit.TypeApartment + ', #crit_' + Crit.LastMinute).on("change", function () {
            const crit = <Crit>parseInt(this.id.substring(5))
            if ($(this).is(":checked")) {
                addFilterCrit(filter, crit);
            } else {
                removeFilterCrit(filter, crit);
            }
            changeFilter();
        });

        $("#formCheckin1,#formCheckin2,#formCheckin3,#formCheckin4").on("click", function () {
            const update = SearchForm.filter.stay_from_to !== 0;
            SearchForm.calFrom = 0;
            SearchForm.calTill = 0;
            SearchForm.filter.stay_from_to = 0;
            if (update) SearchForm.changeFilter();
            SearchForm._calDisplayCheckInOut();
            SearchForm._openCalendar();
            SearchForm.cal.posRefElement($("#search-content"), $(this), {top: 40, left: 0})
        });
        $("#formCheckout1,#formCheckout2,#formCheckout3,#formCheckout4").on("click", function () {
            SearchForm._openCalendar();
            SearchForm.cal.posRefElement($("#search-content"), $(this), {top: 40, left: 0})
        });

        $("body").on("click", (ev) => {
            for (let el = $(ev.target); el.length > 0; el = el.parent()) if (el.hasClass("calendar-modern") || el.hasClass("dates")) return; // Kalender-Klick erkannt?
            SearchForm._closeCalendar();
        });
    }

    private static _calDisplayCheckInOut(d2?: ZpDate) {
        let d1 = SearchForm.calFrom;
        if (!d2) d2 = SearchForm.calTill;
        if (d2 < d1 && d2 != 0) {
            const t = d1;
            d1 = d2;
            d2 = t;
        }
        if (d1 == d2) d2 = 0;
        $("#formCheckin1,#formCheckin2,#formCheckin3,#formCheckin4").val(d1 ? Zp.format(d1) : "");
        $("#formCheckout1,#formCheckout2,#formCheckout3,#formCheckout4").val(d2 ? Zp.format(d2) : "");
    }

    private static _openCalendar() {
        if (SearchForm.cal) return;
        SearchForm.cal = new ZpCalendar(SearchForm.calFrom, (el, d) => {
            SearchForm.calTill = SearchForm.calFrom;
            SearchForm.calFrom = d;
            if (!SearchForm.calTill) SearchForm.calTill = SearchForm.calFrom;
            SearchForm.cal.markDays(SearchForm.calFrom, SearchForm.calTill);

            const oldStay = SearchForm.filter.stay_from_to;
            if (SearchForm.calFrom > 0 && SearchForm.calTill > 0 && Math.abs(SearchForm.calFrom - SearchForm.calTill) >= 1) {
                SearchForm.filter.stay_from_to = SearchForm.calFrom < SearchForm.calTill
                    ? ((SearchForm.calTill - SearchForm.calFrom) & 0x3ff) | (SearchForm.calFrom << 10)
                    : ((SearchForm.calFrom - SearchForm.calTill) & 0x3ff) | (SearchForm.calTill << 10);
            } else {
                Search.filter.stay_from_to = 0;
            }
            SearchForm._calDisplayCheckInOut();
            if (SearchForm.filter.stay_from_to !== oldStay) {
                SearchForm.changeFilter();
                SearchForm._closeCalendar();
            }
        }, (el, d, hov) => {
            if (!SearchForm.cal || !SearchForm.calFrom) return;
            if (hov) {
                SearchForm.cal.markDays(SearchForm.calFrom, d);
                SearchForm._calDisplayCheckInOut(d);
            } else {
                SearchForm.cal.markDays(SearchForm.calFrom, SearchForm.calTill);
                SearchForm._calDisplayCheckInOut();
            }
        });
        if (SearchForm.calFrom && SearchForm.calTill) SearchForm.cal.markDays(SearchForm.calFrom, SearchForm.calTill);
        $("#search-content").append(SearchForm.cal.calendarDiv);
    }

    private static _closeCalendar() {
        if (SearchForm.cal) {
            SearchForm.cal.calendarDiv.remove();
            SearchForm.cal = null;
        }
        if ((SearchForm.calFrom !== 0 && SearchForm.calTill === 0) || (SearchForm.calFrom == SearchForm.calTill)) {
            SearchForm.calFrom = 0;
            SearchForm.calTill = 0;
        }
        SearchForm._calDisplayCheckInOut();
    }

    private static _updateActiveFilters() {
        const activeFilters = $("#active-filters").empty();

        const ext = Search.filterExt;

        for (let i = 0; i < ext.active_crits.length; i++) {
            const c = ext.active_crits[i];
            if (SearchForm.filter.crits.indexOf(c) < 0) continue;

            const name = ext.crit_names[c];
            const btn = $('<button class="btn btn-default btn-search-filters"><span>' + name + '</span> <i class="css-icons" data-icon="" data-icon-text="clear" aria-hidden="true"></i></button>');
            btn.on("click", () => {
                removeFilterCrit(SearchForm.filter, c);
                SearchForm.changeFilter();
            })
            activeFilters.append($('<li class="active-filter-container"></li>').append(btn));
        }
    }

    static reset() {
        const fc = (crit: Crit) => SearchForm.filter.crits.indexOf(crit) >= 0;

        const priceSlider = $('#price-range')
        if (priceSlider.length && priceSlider[0].noUiSlider) {
            let from = 10;
            let till = 1000;
            if ((SearchForm.filter.price_from_to & 0x3ff) !== 0) from = SearchForm.filter.price_from_to & 0x3ff;
            if ((SearchForm.filter.price_from_to >> 10) !== 0) till = SearchForm.filter.price_from_to >> 10;
            priceSlider[0].noUiSlider.set([from, till]);
        }

        const pax = $('#formPax1, #formPax2');
        pax.val(1);
        if (fc(Crit.PersonsFrom2)) pax.val(2);
        if (fc(Crit.PersonsFrom3)) pax.val(3);
        if (fc(Crit.PersonsFrom4)) pax.val(4);
        if (fc(Crit.PersonsFrom5)) pax.val(5);
        if (fc(Crit.PersonsFrom6)) pax.val(6);
        if (fc(Crit.PersonsFrom7)) pax.val(7);
        if (fc(Crit.PersonsFrom8)) pax.val(8);
        if (fc(Crit.PersonsFrom9)) pax.val(9);
        if (fc(Crit.PersonsFrom10)) pax.val(10);

        const bedrooms = $('#formBedrooms');
        bedrooms.val(0);
        if (fc(Crit.BedroomFrom1)) bedrooms.val(1);
        if (fc(Crit.BedroomFrom2)) bedrooms.val(2);
        if (fc(Crit.BedroomFrom3)) bedrooms.val(3);
        if (fc(Crit.BedroomFrom4)) bedrooms.val(4);

        const distWater = $('#formDistWater');
        distWater.val(0);
        if (fc(Crit.WaterTill250)) distWater.val(250);
        if (fc(Crit.WaterTill500)) distWater.val(500);
        if (fc(Crit.WaterTill1000)) distWater.val(1000);
        if (fc(Crit.WaterTill10000)) distWater.val(10000);

        const distSkilift = $('#formDistSkilift');
        distSkilift.val(0);
        if (fc(Crit.SkiliftTill250)) distSkilift.val(250);
        if (fc(Crit.SkiliftTill500)) distSkilift.val(500);
        if (fc(Crit.SkiliftTill1000)) distSkilift.val(1000);
        if (fc(Crit.SkiliftTill10000)) distSkilift.val(10000);

        for (let crit = Crit.Internet; crit < Crit.BedroomFrom1; crit++) {
            $("#crit_" + crit).prop('checked', fc(crit));
        }
        $("#crit_" + Crit.LastMinute).prop('checked', fc(Crit.LastMinute));
        $("#crit_" + Crit.TypeHolidayhome).prop('checked', fc(Crit.TypeHolidayhome));
        $("#crit_" + Crit.TypeApartment).prop('checked', fc(Crit.TypeApartment));

        if (SearchForm.filter.stay_from_to !== 0) {
            SearchForm.calFrom = SearchForm.filter.stay_from_to >> 10;
            SearchForm.calTill = SearchForm.calFrom + (SearchForm.filter.stay_from_to & 0x3ff);
        } else {
            SearchForm.calFrom = 0;
            SearchForm.calTill = 0;
        }
        SearchForm._calDisplayCheckInOut();
        SearchForm._updateActiveFilters();
    }

}
